import React__default from 'react';
import { useController } from 'react-hook-form';
import { TimeInput } from '../../../atoms/TimeInput.js';
import { FormItem } from '../FormItem.js';
import { ReadOnlyField, formatReadOnlyValue } from './ReadOnlyFormField.js';

/**
 * TimeFormField - A form field component for time input.
 *
 * Supports both string format (e.g., "14:30") and TimeValue object format.
 * The component automatically converts between formats as needed via the field adapter.
 *
 * @example
 * ```tsx
 * <Form schema={schema} onSubmit={handleSubmit}>
 *   <TimeFormField
 *     schemaField="appointmentTime"
 *     labelText="Appointment Time"
 *   />
 * </Form>
 * ```
 */
function TimeFormField({ schemaField, labelText, descriptionText, isReadOnly, isDisabled, required, className, id, linkedField, showFieldToggle = false, ...timeInputProps }) {
    const { field } = useController({
        name: schemaField,
        shouldUnregister: false,
    });
    if (isReadOnly) {
        return (React__default.createElement(ReadOnlyField, { label: labelText, value: formatReadOnlyValue(field.value, 'time'), description: descriptionText, required: required, className: className }));
    }
    return (React__default.createElement(FormItem, { schemaField: schemaField, labelText: labelText, descriptionText: descriptionText, required: required, className: className, id: id, isDisabled: isDisabled, linkedField: linkedField, showFieldToggle: showFieldToggle },
        React__default.createElement(TimeInput, { ...timeInputProps, isDisabled: isDisabled, isReadOnly: isReadOnly })));
}

export { TimeFormField };
//# sourceMappingURL=TimeFormField.js.map
